import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that implements the Array.some() method.
 * Checks if a value exists in a given array.
 */
@Pipe({
  name: 'rdsArraySome',
})
export class RdsArraySomePipe implements PipeTransform {
  transform<T>(array: T[], value: T): boolean {
    if (!array || !array.length) {
      return false;
    }
    return array.some((v) => v === value);
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [RdsArraySomePipe],
  declarations: [RdsArraySomePipe],
})
export class RdsArraySomePipeModule {}
